import { createContext } from 'react';

interface Context {
  activeId?: string;
  changeActiveId?: (value: string) => void;
}

export default createContext<Context>({});
